import { SaleConditionForm } from './SaleConditionForm'
import { withSaleConditionForm } from './withSaleConditionForm'

const Connected = withSaleConditionForm(SaleConditionForm)

export { Connected as SaleConditionForm }
